import ajaxRequest from '@/utils/request';
import router from '@/router/index';

const state = {
    loginCheckCompleted: false,
    isLoggedIn: false
};

const getters = {

};

const actions = {
    login(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/auth/login/',
                method: 'POST',
                params,
                success(response) {
                    context.commit('loginCheck', true);
                    resolve();
                },
                failure({errorCode = null, errorMessage = null}) {
                    reject({errorMessage, errorCode});
                }
            });
        });
    },
    loginCheck(context) {
        ajaxRequest({
            url: '/auth/check/',
            success({user_logged_in}) {
                context.commit('loginCheck', user_logged_in);
            }
        });
    },
    primaryRegistration(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/auth/primary_registration/?from_app=true',
                method: 'POST',
                params,
                success(response) {
                    router.push({name: 'Registration'});
                    resolve();
                },
                failure({errorMessage = null, errorList = []}) {
                    reject({errorMessage, errorList});
                }
            });
        });
    },
    registrate(context, profile) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/auth/registration/',
                method: 'POST',
                params: profile,
                success(response) {
                    context.commit('registrationSuccess');

                    resolve();
                },
                failure(response) {
                    reject(response.errorMessage);
                }
            });
        });
    },
    sendRecoverPasswordLink(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/auth/recover/send_link/',
                method: 'POST',
                params,
                success(response) {
                    resolve(response.message);
                }
            });
        });
    },
    changePassword(context, params) {
        return new Promise((response, reject) => {
            ajaxRequest({
                url: '/auth/recover/',
                method: 'POST',
                params,
                success(response) {
                    context.commit('recoverPasswordSuccess');
                },
                failure(response) {
                    reject(response.errorMessage);
                }
            });
        });
    },
    logout(context) {
        ajaxRequest({
            url: '/auth/logout/',
            success() {
                context.commit('logout');
            }
        });
    }
};

const getInitialData = store => {
    Promise.all([
        store.dispatch('getProfile'),
        store.dispatch('getTariffPlanState'),
        store.dispatch('getSelectedShop')
    ]).then(_ => {
        /* Chatra('setIntegrationData', {
            name: `${store.state.users.profile.first_name} ${store.state.users.profile.last_name}`,
            email: store.state.users.profile.email,
            phone: store.state.users.profile.phone,
            // notes: 'Looking for courage...',

            // any number of custom properties
            'Магазин': store.state.localStorage.selectedShop.domain,
            'Тариф оплачен до': (
                store.state.payments.payedTo &&
                (new Date(store.state.payments.payedTo)).toLocaleDateString('ru-RU')
            ),
            'API-токен': store.state.localStorage.selectedShop.api_token
        }); */
    });
};

const mutations = {
    loginCheck(state, isLoggedIn) {
        state.loginCheckCompleted = true;
        state.isLoggedIn = isLoggedIn;

        if (isLoggedIn) {
            if (router.currentRoute.meta.withoutAuth) router.push({name: 'DeliveryServices'});

            getInitialData(this);
        } else if (!router.currentRoute.meta.withoutAuth) {
            router.push({name: 'Login'});
        }
    },
    registrationSuccess(state) {
        state.isLoggedIn = true;
        router.push({name: 'DeliveryServices'});

        getInitialData(this);
    },
    recoverPasswordSuccess(state) {
        state.isLoggedIn = true;
        router.push({name: 'Calculator'});

        this.dispatch('getProfile');
    },
    logout(state) {
        state.isLoggedIn = false;
        router.push({name: 'Login'});
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js